import { ADD_MEMBER_TIMESHEET_SUCCESS, ADD_MEMBER_TIMESHEET_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const addMemberTimesheetReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_MEMBER_TIMESHEET_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADD_MEMBER_TIMESHEET_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addMemberTimesheetReducer;
